export const PortfolioHierarchyRouteInformation = {
  INDEX: {
    label: 'component.page_header.portfolio_hierarchy',
    navigationPath: '/portfolio-hierarchy/portfolios',
    routePath: '/',
  },
  PORTFOLIOS: {
    label: 'component.page_header.portfolios',
    navigationPath: '/portfolio-hierarchy/portfolios',
    routePath: 'portfolios',
  },
  REGULATION_OBJECTS: {
    label: 'component.page_header.regulation_objects',
    navigationPath: '/portfolio-hierarchy/regulation-objects',
    routePath: 'regulation-objects',
  },
  ACTIVATION_GROUPS: {
    label: 'component.page_header.activation_groups',
    navigationPath: '/portfolio-hierarchy/activation-groups',
    routePath: 'activation-groups',
  },
  REGULATION_OBJECT_DETAILS: {
    label: 'component.page_header.regulation_object_details',
    navigationPath: (countryCode: string, regulationObjectCode: string) =>
      `/portfolio-hierarchy/regulation-objects/${encodeURIComponent(countryCode)}/${encodeURIComponent(regulationObjectCode)}`,
    routePath: 'regulation-objects/:countryCode/:regulationObjectCode',
  },
} as const
